import { http } from "../utils/http";

/** Конструктор адаптации и дашборд (backend /v1/adaptation/builder). [Claude] 2026-11-02, Чат 3, №7 */
const B = "/adaptation/builder";

export const getBuilderState = () => http.get(`${B}/state`);

export const createQuestion = (payload) => http.post(`${B}/questions`, payload);
export const updateQuestion = (id, payload) => http.put(`${B}/questions/${id}`, payload);
export const archiveQuestion = (id, archived = true) => http.post(`${B}/questions/${id}/archive`, { archived });

export const createRole = (payload) => http.post(`${B}/roles`, payload);
export const updateRole = (id, payload) => http.put(`${B}/roles/${id}`, payload);

export const createForm = (payload) => http.post(`${B}/forms`, payload);
export const updateForm = (id, payload) => http.put(`${B}/forms/${id}`, payload);
export const copyForm = (id) => http.post(`${B}/forms/${id}/copy`, {});

export const previewRule = (payload) => http.post(`${B}/rules/preview`, payload);
export const createRule = (payload) => http.post(`${B}/rules`, payload);
export const updateRule = (id, payload) => http.put(`${B}/rules/${id}`, payload);
export const syncRule = (id) => http.post(`${B}/rules/${id}/sync`, {});

export const setParticipantPerson = (formId, participantName) =>
    http.patch(`${B}/participant-forms/${formId}`, { participant_name: participantName });

export const getDashboard = ({ dateFrom, dateTo, department, archived } = {}) => {
    const params = new URLSearchParams();
    if (dateFrom) params.set("date_from", dateFrom);
    if (dateTo) params.set("date_to", dateTo);
    if (department) params.set("department", department);
    if (archived) params.set("archived", "true");
    const qs = params.toString();
    return http.get(`${B}/dashboard${qs ? `?${qs}` : ""}`);
};
export const getDashboardViews = () => http.get(`${B}/dashboard/views`);
export const saveDashboardView = (payload) => http.post(`${B}/dashboard/views`, payload);
export const deleteDashboardView = (id) => http.del(`${B}/dashboard/views/${id}`);
